import React from 'react';
import MetadataSection from './MetadataSection';

interface MetadataIdentitySectionProps {
  primaryFields: React.ReactNode;
  secondaryFields: React.ReactNode;
  children?: React.ReactNode;
  status?: {
    label: string;
    tone?: 'ready' | 'needed' | 'attention';
  };
}

const MetadataIdentitySection: React.FC<MetadataIdentitySectionProps> = ({
  primaryFields,
  secondaryFields,
  children,
  status,
}) => (
  <MetadataSection
    id="metadata-identity"
    title="Book identity"
    description="Source details for stores and translations."
    tourId="metadata-identity"
    status={status}
  >
    <div className="metadata-identity-layout">
      <div className="metadata-field-grid metadata-field-grid--identity-primary">{primaryFields}</div>
      <div className="metadata-field-grid metadata-field-grid--identity-secondary">{secondaryFields}</div>
    </div>
    {children}
  </MetadataSection>
);

export default MetadataIdentitySection;
